/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as seriesRecordingOptionsReducer } from "./seriesRecordingOptionsSlice";
export {
  showSeriesRecordingOptions,
  dismissSeriesRecordingOptions,
  resetSeriesRecordingOptions,
  activateOption,
  cycleOptionValue,
  focusUp,
  focusDown,
  focusLeft,
  focusRight,
  setFocus,
  openOptionValue,
  closeOptionValue,
  setActiveOptionFocusIndex,
  tickActiveOptionFocus,
  focusActiveOptionAction,
  confirmActiveOptionValue,
  commitPendingActiveOptionValue,
  SAVE_ACTION_INDEX,
  CANCEL_ACTION_INDEX,
  selectIsSeriesRecordingOptionsVisible,
  selectSeriesRecordingOptionsTitle,
  selectSeriesRecordingOptions,
  selectSeriesRecordingUcid,
  selectSeriesRecordingMode,
  selectSeriesRecordingSaveLabel,
  selectSeriesRecordingCancelLabel,
  selectSeriesRecordingFocus,
  selectSeriesRecordingActivatedOptionId,
  selectSeriesRecordingDismissReason,
  selectIsActiveOptionVisible,
  selectActiveOptionFocusIndex,
  selectActiveOptionActionFocusIndex,
  selectActiveOptionPendingIndex,
  selectActiveRecordingOption
} from "./seriesRecordingOptionsSlice";
export {
  loadSeriesRecordingOptions,
  saveSeriesRecordingOptions
} from "./seriesRecordingOptionsThunks";
export { RecordingOptionListType } from "./seriesRecordingOptions.types";
export type {
  RecordingOption,
  RecordingOptionListType as RecordingOptionListTypeValue,
  ActiveOptionState,
  SeriesRecordingFocus,
  SeriesRecordingFocusZone,
  SeriesRecordingMode,
  SeriesRecordingDismissReason,
  SeriesRecordingOptionsConfig,
  SeriesRecordingOptionsState
} from "./seriesRecordingOptions.types";
